/**
 * 交流合作专区 上合新闻tab - 政策文件 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/dynamicInformation/policy/page`, { params: data })
  },
  getDetail: (id, data) => {
    return request.get(`/api/frLegalPlatform/web/dynamicInformation/policy/${id}`, { params: data })
  }
}
